module.exports = __webpack_public_path__ + "img/tappay.2ee41b2d.png";